import { render } from "./ModalConfirmSheet.vue?vue&type=template&id=490663bd&scoped=true"
import script from "./ModalConfirmSheet.vue?vue&type=script&lang=js"
export * from "./ModalConfirmSheet.vue?vue&type=script&lang=js"

import "./ModalConfirmSheet.vue?vue&type=style&index=0&id=490663bd&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490663bd"]])

export default __exports__